import { useEffect, useState } from 'react';
import { useTerminal } from '../lib/store';
import { clockTime, longDate } from '../lib/format';
import { Avatar, Dot } from './ui';

export function TopBar({ title, subtitle, onBack }: { title: string; subtitle?: string; onBack?: () => void }) {
  const { state, online, queued, logout } = useTerminal();
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <header className="topbar">
      {onBack ? (
        <button className="btn btn--ghost" onClick={onBack}>
          ← Volver
        </button>
      ) : null}
      <div>
        <div className="topbar__title">{title}</div>
        {subtitle ? <div className="topbar__sub">{subtitle}</div> : null}
      </div>
      <div className="topbar__spacer" />

      {queued > 0 ? <span className="queue-badge">⇅ {queued} sin enviar</span> : null}

      <div className="conn">
        <Dot tone={online ? 'ok' : 'danger'} />
        {online ? 'En línea' : 'Sin conexión'}
      </div>

      <div style={{ textAlign: 'right' }}>
        <div className="topbar__clock">{clockTime(now)}</div>
        <div className="topbar__sub capitalize-first">{longDate(now)}</div>
      </div>

      {state ? (
        <button className="btn btn--ghost" onClick={logout} title="Cerrar sesión">
          <Avatar name={state.employee.fullName} small />
          Salir
        </button>
      ) : null}
    </header>
  );
}
